import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

export interface DashboardIntroStatus {
    show_intro: boolean
}

export interface DashboardIntroAcknowledgment {
    acknowledged: boolean
    acknowledged_at: string
}

export const dashboardIntroApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboardIntroStatus: builder.query<DashboardIntroStatus, void>({
            query: () => apiEndpoints.dashboardIntro.getStatus,
            providesTags: ['DashboardIntro'],
        }),

        acknowledgeDashboardIntro: builder.mutation<DashboardIntroAcknowledgment, void>({
            query: () => ({
                url: apiEndpoints.dashboardIntro.acknowledge,
                method: 'POST',
            }),
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                const patch = dispatch(
                    dashboardIntroApi.util.updateQueryData('getDashboardIntroStatus', undefined, (draft) => {
                        draft.show_intro = false
                    }),
                )
                try {
                    await queryFulfilled
                } catch {
                    patch.undo()
                }
            },
        }),
    }),
    overrideExisting: false,
})

export const { useGetDashboardIntroStatusQuery, useAcknowledgeDashboardIntroMutation } = dashboardIntroApi
